import cn from 'classnames';
import PropTypes from 'prop-types';
import LillyLogoSvg from './LillyLogoSvg.jsx';

import {
  getValidSizeClass
} from './lillyLogo.helpers.js';

function LdsLillyLogo({
  size = 'lg',
  color = 'red',
  className = '',
  link = 'https://www.lilly.com',
  ariaLabel = 'Visit Lilly.com',
  removeLink = false,
  paddingOverrideClass = '', // Deprecated, Remove in V2
  title = 'Lilly',
  ...rest
}) {
  const elementClasses = cn(
    'lds-lilly-logo',
    getValidSizeClass(size),
    paddingOverrideClass,
    className
  );

  if (removeLink) {
    return (
      <div
        className={elementClasses}
        {...rest}
      >
        <LillyLogoSvg color={color} title={title} />
      </div>
    );
  }

  return (
    <a
      href={link}
      className={elementClasses}
      aria-label={ariaLabel}
      {...rest}
    >
      <LillyLogoSvg color={color} title={title} />
    </a>
  );
}

export default LdsLillyLogo;

LdsLillyLogo.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'fit']),
  color: PropTypes.oneOf(['red', 'white', 'black']),
  className: PropTypes.string,
  link: PropTypes.string,
  ariaLabel: PropTypes.string,
  removeLink: PropTypes.bool,
  title: PropTypes.string,
};
